<header id="page-topbar">
  <div
    class="navbar-header position-relative border-bottom pb-3 flex-wrap-reverse"
  >
    <!-- Left: Mobile Toggle & Quick Link -->
    <div class="d-flex align-items-center gap-2">
      <a
        style="height: auto"
        class="lh-1 p-0 noti-icon d-lg-none pointer"
        id="page-header-notifications-dropdown"
        (click)="toggleMobileMenu($event)"
      >
        <span class="notif_circle">
          <i class="isax isax-menu-1 text-primary fs-5"></i>
        </span>
      </a>

      <a class="lh-1 p-0" routerLink="/academies" [attr.title]="'SUPER_ADMIN.MENU.ACADEMIES' | translate">
        <i class="isax isax-home text-gray-600 fs-5"></i>
      </a>
    </div>

    <!-- Right: Theme, Lang, Notification & Account Dropdown -->
    <div class="d-flex align-items-center mb-3 mb-md-0">
      <div class="d-flex gap-2 gap-md-3 align-items-center me-3 me-md-60px">
        <!-- Dark Mode Toggle Button -->
        <a
          class="icon-box p-0 pointer"
          (click)="toggleDarkMode()"
          [attr.title]="
            isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'
          "
        >
          <i [class]="isDarkMode ? 'bx bx-sun fs-5' : 'bx bx-moon fs-5'"></i>
        </a>

        <!-- Language Switcher Button -->
        <a
          class="icon-box p-0 pointer"
          (click)="toggleLanguage()"
          [attr.title]="
            currentLang === 'ar' ? 'Switch to English' : 'التبديل للعربية'
          "
        >
          {{ currentLang === 'ar' ? 'EN' : 'AR' }}
        </a>

        <!-- Notification / Inbox quick button -->
        <a
          class="icon-box p-0 pointer position-relative"
          routerLink="/inbox"
          [attr.title]="'SUPER_ADMIN.MENU.INBOX' | translate"
        >
          <i class="isax isax-notification fs-5"></i>
        </a>
      </div>

      <!-- Account Dropdown -->
      <mg-account-dropdown></mg-account-dropdown>
    </div>
  </div>
</header>
